import { defineComponent as _defineComponent } from 'vue'
import type { ProfileNode } from '@/features/user-profile/types';

import ProfileBox from '@/features/user-profile/components/ProfileBox.vue';

import { useUserProfile } from '@/features/user-profile/composables/useUserProfile';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileView',
  props: {
    profile: null
  },
  emits: ["loadNext"],
  setup(__props: any) {





const { setView } = useUserProfile();

return { __sfc: true,setView, ProfileBox, faChevronLeft }
}

})